// src/components/CollaboratorDetailModal.jsx
import React from "react";
import { Modal, Button, Badge } from "react-bootstrap";

const CollaboratorDetailModal = ({ show, onClose, collaborator }) => {
  if (!collaborator) return null;

  return (
    <Modal show={show} onHide={onClose} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>Détails du collaborateur</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ padding: "10px 20px" }}>
          <p><strong>Nom complet :</strong> {collaborator.fullName}</p>
          <p><strong>Email :</strong> {collaborator.email}</p>
          <p><strong>Rôle :</strong> {collaborator.role}</p>
          <p><strong>Date de création :</strong> {new Date(collaborator.createdDate).toLocaleString("fr-FR")}</p>

          <div style={{ marginTop: "15px" }}>
            <strong>Permissions :</strong>
            <div style={{ marginTop: "8px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
              {collaborator.permissions && collaborator.permissions.length > 0 ? (
                collaborator.permissions.map((perm, index) => (
                  <Badge
                    key={index}
                    bg="primary"
                    style={{ fontSize: "12px", fontWeight: "400", padding: "6px 10px" }}
                  >
                    {perm}
                  </Badge>
                ))
              ) : (
                <span>Aucune permission</span>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CollaboratorDetailModal;
